import React from 'react';
import SEO from '../components/SEO';
import PropTypes from "prop-types";
import Header from "../partials/header/Header";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb';
import Footer from '../container/Footer/Footer';
import ServiceData from "../data/work/ServiceDetails.json";
import ServiceDetailContainer from '../container/service/ServiceDetailContainer';
import ScrollToTop from '../components/ScrollToTop.jsx';



const ServiceDetails = ({match: {params: {id}}}) => {
    const workId = parseInt(id, 10)
    const data = ServiceData.filter(work => work.id === workId);
    return (
        <React.Fragment>
            <SEO title="Tetrahed || Service Details" />
            <Header />
            <Breadcrumb
                image="images/bg/breadcrumb-bg-two.jpg"
                title={data[0]?.title}
                content="Home"
                contentTwo="Industries"
            />
            <ServiceDetailContainer data={data[0]} />
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    )
}

ServiceDetails.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.oneOfType([    
                PropTypes.string,
                PropTypes.number
            ])
        })
    })
}

export default ServiceDetails;